import { Type } from '../types.mjs';
import { isCollapsedSelectionWithinNode } from '../../../../queries/isCollapsedSelectionWithinNode.mjs';

function isLinkSelected(editor, element) {
  return isCollapsedSelectionWithinNode(editor, {
    type: Type,
    element
  });
}

export { isLinkSelected };
